import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEstopOn = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M5.855 0L0 5.855V14.145L5.855 20H14.145L20 14.145V5.855L14.145 0H5.855ZM5.971 4.627H13.713V6.497H8.125V8.737H13.254V10.57H8.125V13.285H13.971V15.184H5.971V4.627Z",
		fill: "currentColor"
	})
});
export default SvgEstopOn;
